module.exports = __webpack_public_path__ + "static/media/PDF_91.fd3e9753.pdf";